




import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { ListModelUtil } from '@/model-utils/list-model-util'
import AddEditItem from '@/components/add-flows/AddEditItem.vue';
import { ProductItem } from '@/models/items/product-item-model';
import { PlaceItem } from '@/models/items/place-item-model';
import { GenericItem } from '@/models/items/generic-item-model';
import { MediaItem } from '@/models/items/media-item-model';
import { ListModel } from '@/models/list-model';
import {
  AbstractItemModel,
  ItemType
} from '../models/items/abstract-item-model';

@Component({
  components: {
    AddEditItem
  }
})
export default class AddItem extends Vue {
  @Prop(ListModel) list?: ListModel;
  @Prop(String) mode?: string;
  public item: AbstractItemModel;

  myList: ListModel = null;

  waitingForList: boolean = false;

  created() {
    const myMode = this.mode || this.$route.query.mode;

    if (this.list) {
      this.myList = this.list;
    } else if (this.$route.query.listId) {
      this.waitingForList = true;
      ListModelUtil.hydrateList(this.$route.query.listId as string).then((l) => {
        this.myList = l
        this.waitingForList = false;
      })
    }

    if (myMode === ItemType.Product.toString()) {
      this.item = new ProductItem();
    } else if (myMode === ItemType.Place.toString()) {
      this.item = new PlaceItem();
    } else if (myMode === ItemType.Generic.toString()) {
      this.item = new GenericItem();
    } else if (myMode === ItemType.Media.toString()) {
      
      this.item = new MediaItem();
      
    } else {
      throw new Error('unknown item type ' + myMode);
    }
  }
}
